// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Accordion_accordionItemContainer__pAxDg {
    border-bottom: 1px solid var(--color-108);
}

.Accordion_hideLastDivider__Yf77E {
    border-bottom: none;
}

.Accordion_accordionItemContainer__pAxDg:nth-of-type(1) {
    border-top: 1px solid var(--color-108);
}

.Accordion_summaryContainer__xmGIq {
    display: flex;
    height: 50px;
    line-height: 50px;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    letter-spacing: 0.12px;
}

.Accordion_summaryIcon__wboZO {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: auto;
    text-align: center;
    color: var(--color-secondary);
    margin: 0 0 0 auto;
    transition: all .25s ease-in-out;
}

.Accordion_detailsContainer__mcwXN {
    overflow: hidden;
}

.Accordion_detailsContainer__mcwXN.Accordion_closed__Rf8pq {
    transition: max-height ease-in-out .28s;
}

.Accordion_detailsContainer__mcwXN.Accordion_open__7tSvh {
    transition: max-height ease-in-out .28s;
}

.Accordion_rotated__spWUr {
    transform: rotate(180deg);
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Accordion/Accordion.module.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".accordionItemContainer {\n    border-bottom: 1px solid var(--color-108);\n}\n\n.hideLastDivider {\n    border-bottom: none;\n}\n\n.accordionItemContainer:nth-of-type(1) {\n    border-top: 1px solid var(--color-108);\n}\n\n.summaryContainer {\n    display: flex;\n    height: 50px;\n    line-height: 50px;\n    font-weight: bold;\n    font-size: 14px;\n    cursor: pointer;\n    letter-spacing: 0.12px;\n}\n\n.summaryIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: auto;\n    text-align: center;\n    color: var(--color-secondary);\n    margin: 0 0 0 auto;\n    transition: all .25s ease-in-out;\n}\n\n.detailsContainer {\n    overflow: hidden;\n}\n\n.detailsContainer.closed {\n    transition: max-height ease-in-out .28s;\n}\n\n.detailsContainer.open {\n    transition: max-height ease-in-out .28s;\n}\n\n.rotated {\n    transform: rotate(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordionItemContainer": `Accordion_accordionItemContainer__pAxDg`,
	"hideLastDivider": `Accordion_hideLastDivider__Yf77E`,
	"summaryContainer": `Accordion_summaryContainer__xmGIq`,
	"summaryIcon": `Accordion_summaryIcon__wboZO`,
	"detailsContainer": `Accordion_detailsContainer__mcwXN`,
	"closed": `Accordion_closed__Rf8pq`,
	"open": `Accordion_open__7tSvh`,
	"rotated": `Accordion_rotated__spWUr`
};
export default ___CSS_LOADER_EXPORT___;
